<template>
  <div
    class="h-100 w-100"
    :class="[singleDatePickerMode ? 'mb-0 h-auto' : null, (singleDatePickerMode && isInvalidSingleDate) || isInvalidDepartureDate ? null : 'error']"
  >
    <date-range-picker
      :ref="'multipleDateRangePickerStart' + id"
      v-model="dateRange"
      :locale-data="currentLocaleData"
      :date-range-picker-mode="!dateRangePickerMode ? 'single' : 'range'"
      :ranges="ranges"
      :single-custom="singleCustom"
      :opens="openDirection"
      class="customMultipleDateRangePicker multipleDateRangePickerStart"
      :min-date="minDate"
      :max-date="maxDate"
      :auto-apply="autoApply"
      :always-show-calendars="alwaysShowCalendars"
      :class="[
        dateBorderClass ? 'dateBorder' : null,
        singleDatePickerMode ? 'singleDatePickerMode' : null,
        trainInformation ? 'trainInformationDatePicker' : null,
      ]"
      :side-arrows-on="sideArrowsOn"
      :month-count="monthCount"
      :side-by-side="sideBySide"
      :left-direction-for-first-calendar="leftDirectionForFirstCalendar"
      :right-direction-for-first-calendar="rightDirectionForFirstCalendar"
      :left-direction-for-second-calendar="leftDirectionForSecondCalendar"
      :right-direction-for-second-calendar="rightDirectionForSecondCalendar"
      :show-dropdowns="showDropdowns"
      :single-date-picker-mode="singleDatePickerMode"
      :window-width="windowWidth"
      :disabled="disabled"
      @select="selectDate($event)"
      @start-selection="startDateSelection($event)"
      @finish-selection="
        finishDateSelection($event);
        selectDate();
        $emit('endDateInputEmit', dateFormatter(selectedEndDate));
      "
      @toggle="
        toggleBorderClass($event);
        toggleEmitDate($event);
      "
      @prevMonth="prevMonth($event)"
      @nextMonth="nextMonth($event)"
      @clickabilityApplyButton="clickabilityApplyButton = $event"
    >
      <template v-if="isMinimalDatePicker">
        <div slot="input" class="h-100">
          <div class="row no-gutters dateInputArea">
            <div class="pr-0 col-6">
              <validation-observer ref="startDateInputObserver" slim>
                <validation-provider v-slot="validationContext" :rules="{ required: true }" slim>
                  <div class="datePickerInput departureDate">
                    <div class="form-label-group mb-0">
                      <input v-model="startDateInput" type="text" class="form-control" readonly @click="setDateRangeViewValues()" />
                      <!-- <label>Gidiş Tarihi</label> -->
                    </div>
                  </div>
                </validation-provider>
              </validation-observer>
            </div>
            <div v-show="!singleDatePickerMode" class="col-6">
              <!-- v-show="seferType === 0" -->
              <!-- <validation-observer ref="endDateInputObserver" slim>
                <validation-provider :rules="{ required: true }" v-slot="validationContext" slim> -->
              <div class="datePickerInput arrivalDate">
                <div
                  v-show="!dateRangePickerMode"
                  class="btnReturnArea justify-content-center"
                  @click="
                    datePickerSwitchMode(true);
                    selectEndDateWithoutChangingStartDateDropdownEmit(true);
                  "
                >
                  <button type="button" class="btn btnAddReturn">{{ $t("add-return") }}</button>
                </div>
                <div v-show="dateRangePickerMode" class="form-label-group mb-0">
                  <input v-model="endDateInput" type="text" class="form-control" readonly @click="setDateRangeViewValues()" />
                  <!-- <label>Dönüş Tarihi</label> -->
                </div>
              </div>
              <!-- </validation-provider>
            </validation-observer> -->
            </div>
            <!-- <div class="invalid-feedback-inline" v-if="!checkDatesValidation()">
              Lütfen tarihi seçiniz.
            </div> -->
          </div>
        </div>
      </template>
      <template v-else>
        <!-- chooseDay slot -->
        <div slot="chooseDay" class="col-12" :class="isInvalidDepartureDate ? null : 'is-invalid'">
          <div v-show="!singleDatePickerMode" class="row no-gutters">
            <div class="col-6">
              <div class="dateSelectionTextArea">
                <button type="button" class="btn" @click="selectDay('today')">{{ $t("today") }}</button>
                <button type="button" class="btn" @click="selectDay('tomorrow')">{{ $t("tomorrow") }}</button>
              </div>
            </div>
            <div class="col-6">
              <div class="dateSelectionTextArea right">
                <button type="button" class="btn" @click="selectDay('same-day')">{{ $t("same-day") }}</button>
                <button type="button" class="btn" @click="selectDay('next-day')">{{ $t("next-day") }}</button>
              </div>
            </div>
          </div>
        </div>
        <!-- input slot -->
        <div slot="input" class="col-12" :class="singleDatePickerMode ? 'px-0' : null">
          <div
            class="row dateInputArea"
            :class="[(singleDatePickerMode && isInvalidSingleDate) || isInvalidDepartureDate ? null : 'error', singleDatePickerMode ? 'px-0' : null]"
          >
            <div :class="singleDatePickerMode ? 'col-12 px-0' : 'col-6 pr-0'">
              <!-- <div class="dateSelectionTextArea">
                <button type="button" class="btn" @click="selectDay('today'), datePickerClose()">Bugün</button>
                <button type="button" class="btn" @click="selectDay('tomorrow'), datePickerClose()">Yarın</button>
              </div> -->
              <validation-observer ref="startDateInputObserver" slim>
                <validation-provider
                  v-slot="validationContext"
                  :rules="checkStartDateInputRules()"
                  :custom-messages="{
                    required: $t('required-field-v2'),
                    regex: $t('please-enter-in-appropriate-format'),
                    is_birthdate_in_range: $t('seatmap-passenger-information-date-of-birth-does-not-match-the-selected-tariff-age'),
                  }"
                  slim
                >
                  <div class="datePickerInput departureDate">
                    <div class="mb-0" :class="[trainInformation ? 'form-group' : 'form-label-group', validationContext.errors.length > 0 ? 'error' : null]">
                      <input
                        v-mask="startDateInputVMask !== '' ? startDateInputVMask : null"
                        type="text"
                        class="form-control"
                        :readonly="isStartDateInputReadonly"
                        :placeholder="!singleDatePickerMode ? startDateLabel + $t('date-picker-date') : startDateInputPlaceHolder"
                        :value="startDateInput"
                        :class="[!trainInformation ? 'calenderPurpleImg' : null, validationContext.errors.length > 0 ? 'is-invalid' : null]"
                        :disabled="disabled"
                        @input="setValue($event)"
                        @click="clickabilityApplyButton = false"
                      />
                      <label v-show="!singleDatePickerMode">{{ startDateLabel }} {{ $t("date-picker-date") }}</label>
                    </div>
                    <div v-show="validationContext.errors.length > 0" class="invalid-feedback-inline">
                      {{ validationContext.errors.length > 0 ? validationTextFormat(validationContext.errors[0]) : null }}
                    </div>
                  </div>
                </validation-provider>
              </validation-observer>
            </div>

            <div v-show="!singleDatePickerMode" class="col-6 pl-sm-2 pl-1">
              <!-- <div class="dateSelectionTextArea right">
                <button type="button" class="btn" @click="selectDay('same-day'), datePickerClose()">Aynı Gün</button>
                <button type="button" class="btn" @click="selectDay('next-day'), datePickerClose()">Sonraki Gün</button>
              </div> -->
              <!-- v-show="dateRangePickerMode === 0" -->
              <validation-observer v-if="!singleDatePickerMode" ref="endDateInputObserver" slim>
                <validation-provider v-slot="validationContext" :rules="{ required: true }" slim>
                  <div class="datePickerInput">
                    <div
                      v-show="!dateRangePickerMode"
                      class="btnReturnArea"
                      @click="
                        datePickerSwitchMode(true);
                        selectEndDateWithoutChangingStartDateDropdownEmit(true);
                      "
                    >
                      <button type="button" class="btn btnAddReturn">{{ $t("add-return") }}</button>
                    </div>
                    <div v-show="dateRangePickerMode" class="form-label-group mb-0">
                      <input v-model="endDateInput" type="text" class="form-control" readonly :placeholder="endDateLabel + ' ' + $t('date-picker-date')" />
                      <label>{{ endDateLabel }} {{ $t("date-picker-date") }}</label>
                    </div>
                  </div>
                </validation-provider>
              </validation-observer>
            </div>
            <div v-if="!singleDatePickerMode && !isInvalidDepartureDate" class="invalid-feedback-inline">{{ $t("please-select-the-date") }}</div>
          </div>
        </div>
      </template>

      <!-- header slot-->
      <div slot="header" slot-scope="header" class="headerArea mb-2 mb-md-0">
        <button type="button" class="btn btn-danger btnClose" @click="header.clickCancel">{{ $t("please-select-the-date") }}</button>
        <div v-show="!singleDatePickerMode" class="row align-items-md-center align-items-start">
          <div class="col-sm-3">
            <b-dropdown class="directionDropdown" variant="light">
              <template #button-content>
                {{ dateRangePickerMode ? firstModeChoiseText : secondModeChoiseText }}
              </template>
              <b-dropdown-item-button
                @click="
                  datePickerSwitchMode(false);
                  selectEndDateWithoutChangingStartDateDropdownEmit(false);
                  directionDropdownCloseDateRangePicker(false);
                "
              >
                {{ secondModeChoiseText }}
              </b-dropdown-item-button>
              <b-dropdown-item-button
                @click="
                  datePickerSwitchMode(true);
                  selectEndDateWithoutChangingStartDateDropdownEmit(true);
                  directionDropdownCloseDateRangePicker(true);
                "
              >
                {{ firstModeChoiseText }}
              </b-dropdown-item-button>
            </b-dropdown>
          </div>
          <div class="col-sm-9 col-12">
            <div class="row justify-content-end">
              <div class="col-6 pr-0">
                <div class="form-group mb-0">
                  <input
                    type="text"
                    class="form-control calenderPurpleImg"
                    readonly
                    :value="formatDateRangeViewDate(dateRangeView.startDate)"
                    :placeholder="startDateLabel + $t('date-picker-date')"
                  />
                </div>
              </div>
              <div v-show="dateRangePickerMode" class="col-6">
                <div class="form-group mb-0">
                  <input
                    type="text"
                    class="form-control calenderPurpleImg"
                    readonly
                    :value="formatDateRangeViewDate(dateRangeView.endDate)"
                    :placeholder="endDateLabel + ' ' + $t('date-picker-date')"
                  />
                </div>
              </div>
              <div v-show="!singleDatePickerMode && !dateRangePickerMode" class="col-6 align-self-center">
                <div class="form-group mb-0">
                  <button
                    type="button"
                    class="btn btnAddReturn"
                    @click="
                      datePickerSwitchMode(true);
                      selectEndDateWithoutChangingStartDateDropdownEmit(true);
                    "
                  >
                    {{ $t("add-return") }}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <template slot-scope="multipleDateRangePicker" slot:input class="minWidth350">
        {{ multipleDateRangePicker.startDate | dateInputText }} - {{ multipleDateRangePicker.endDate | dateInputText }}
      </template>

      <!-- date slot-->
      <template #date="data">
        <span :id="data.date | dateCellToString">{{ data.date | dateCell }}</span>
        <!-- <span :class="[dateText(data.date),dataTextEnd(date)]" :id="data.date | dateCellToString">{{ data.date | dateCell }}</span> -->
        <!-- tooltip start -->
        <!--                          <div class="text-center">-->
        <!--                            <b-tooltip-->
        <!--                              @show="tooltipArrowShowCss()"-->
        <!--                              :target="data.date | dateCellToString"-->
        <!--                              :triggers="'hover'"-->
        <!--                              :placement="'top'"-->
        <!--                              :custom-class="'seferTooltip'"-->
        <!--                            >-->
        <!--                              <img src="/src/images/icon-no-empty-seat.svg" alt="icon-no-empty-seat" loading="lazy" />-->
        <!--                              <span>Boş Koltuk Yok</span>-->
        <!--                            </b-tooltip>-->
        <!--                          </div>-->
        <!-- tooltip end -->
      </template>
      <!-- footer slot-->
      <div v-if="singleDatePickerMode" slot="footer" slot-scope="footer" class="footerArea">
        <div class="row">
          <div class="col-12">
            <div class="drp-buttons">
              <!--:disabled="!clickabilityApplyButton"-->
              <button type="button" class="applyBtn btn btn-sm btn-primary" @click="footer.clickApply('uygula')">{{ $t("apply") }}</button>
              <button type="button" class="applyBtn btn btn-sm btn-secondary" @click="footer.clickCancel('cancel')">{{ $t("cancel") }}</button>
            </div>
          </div>
        </div>
      </div>
    </date-range-picker>
  </div>
</template>

<script>
import moment from "moment";
import DateRangePicker from "../vue2-daterange-picker/src/components/DateRangePicker.vue";
import Vue from "vue";
import { DropdownPlugin } from "bootstrap-vue";

Vue.use(DropdownPlugin);

export default {
  name: "DateRangePickerWidget",
  components: { DateRangePicker },
  filters: {
    dateInputText(val) {
      return val ? moment(val).format("YYYY-MM-DD") : "";
    },
    dateInputDay(val) {
      return val ? moment(val).lang(this.selectedLanguage).format("dddd") : "";
    },
    dateInputDate(val) {
      return val ? moment(val).lang(this.selectedLanguage).format("DD MMMM") : "";
    },
    dateCell(value) {
      let date = new Date(value);
      return date.getDate();
    },
    dateCellToString(value) {
      let date = new Date(value);
      return moment(date).format("DD MM YYYY");
    },
  },
  props: {
    dateRangeView: {
      type: Object,
      default: () => ({
        startDate: new Date(),
        endDate: null,
      }),
    },
    startDateLabel: {
      type: String,
      default: "Gidiş",
    },
    endDateLabel: {
      type: String,
      default: "Dönüş",
    },
    startTextFilterName: {
      type: String,
      default: "Gidiş",
    },
    startDateTextFilterName: {
      type: String,
      default: "Gidiş Tarihi",
    },
    endTextFilterName: {
      type: String,
      default: "Dönüş",
    },
    endDateTextFilterName: {
      type: String,
      default: "Dönüş Tarihi",
    },
    firstModeChoiseText: {
      type: String,
      default: "Gidiş/Dönüş",
    },
    secondModeChoiseText: {
      type: String,
      default: "Tek Yön",
    },
    customDateRangePickerClass: {
      type: Array,
      default: () => [],
    },
    isInvalidSingleDate: {
      type: Boolean,
      default: false,
    },
    isInvalidDepartureDate: {
      type: Boolean,
      default: false,
    },
    minDate: {
      type: Date,
      default() {
        return new Date();
      },
    },
    maxDate: {
      type: Date,
      default() {
        return new Date(this.minDate.getFullYear(), this.minDate.getMonth() + 12, this.minDate.getDate());
      },
    },
    selectedStartDate: {
      type: [Date, String],
      default() {
        return new Date();
      },
    },
    selectedEndDate: {
      type: [Date, String],
      default() {
        return new Date() || null;
      },
    },
    startDateInput: {
      type: String,
      default: "",
    },
    endDateInput: {
      type: String,
      default: "",
    },
    dateRangePickerMode: {
      type: Boolean,
      default: false,
    },
    ranges: {
      type: Boolean,
      default: false,
    },
    sideArrowsOn: {
      type: Boolean,
      default: true,
    },
    sideBySide: {
      type: Boolean,
      default: true,
    },
    alwaysShowCalendars: {
      type: Boolean,
      default: true,
    },
    autoApply: {
      type: Boolean,
      default: true,
    },
    monthCount: {
      type: Number,
      default: 2,
    },
    singleCustom: {
      type: Boolean,
      default: true,
    },
    openDirection: {
      type: String,
      default: "left",
    },
    leftDirectionForFirstCalendar: {
      type: Boolean,
      default: true,
    },
    rightDirectionForFirstCalendar: {
      type: Boolean,
      default: false,
    },
    leftDirectionForSecondCalendar: {
      type: Boolean,
      default: false,
    },
    rightDirectionForSecondCalendar: {
      type: Boolean,
      default: true,
    },
    isMinimalDatePicker: {
      type: Boolean,
      default: false,
    },
    singleDatePickerMode: {
      type: Boolean,
      default: false,
    },
    showDropdowns: {
      type: Boolean,
      default: false,
    },
    trainInformation: {
      type: Boolean,
      default: false,
    },
    isStartDateInputReadonly: {
      type: Boolean,
      default: true,
    },
    startDateInputPlaceHolder: {
      type: String,
      default: "",
    },
    startDateInputVMask: {
      type: String,
      default: "",
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    isBirthdateInRange: {
      type: Boolean,
      default: false,
    },
    selectedGidisTrip: {
      type: Object,
      default: () => ({}),
    },
    selectedDonusTrip: {
      type: Object,
      default: () => {},
    },
    passengerTypesMap: {
      type: Object,
      default: () => ({}),
    },
    passengerTypeCode: {
      type: Number,
      default: 0,
    },
    isAPet: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      id: null,
      dateBorderClass: false,
      localeData: {
        direction: "ltr",
        format: "dd/mm/yyyy",
        separator: " - ",
        daysOfWeek: ["Paz", "Pzt", "Sal", "Çar", "Per", "Cum", "Cmt"],
        monthNames: ["Ocak", "Şubat", "Mart", "Nisan", "Mayıs", "Haziran", "Temmuz", "Ağustos", "Eylül", "Ekim", "Kasım", "Aralık"],
        firstDay: 1,
      },
      enLocaleData: {
        direction: "ltr",
        format: "dd/mm/yyyy",
        separator: " - ",
        daysOfWeek: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
        monthNames: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"],
        firstDay: 1,
      },
      dateRegex: /^(0?[1-9]|[12]\d|3[01])\.(0?[1-9]|1[0-2])\.(19\d{2}|20\d{2})$/,
      windowWidth: null,
      clickabilityApplyButton: false,
      //dateRange: {
      //  startDate: this.selectedStartDate,
      //  endDate: this.selectedEndDate,
      //},
      // dateRangeView:{
      //   startDate:this.selectedStartDate,
      //   endDate:this.selectedEndDate,
      // }
      // endDateInput: null,
      // startDateInput: null,
    };
  },
  computed: {
    selectedLanguage: {
      get() {
        return this.$store.getters.getLanguage;
      },
    },
    //eslint-disable-next-line vue/return-in-computed-property
    currentLocaleData() {
      if (this.$i18n.locale === "tr") {
        return this.localeData;
      } else if (this.$i18n.locale === "en") {
        return this.enLocaleData;
      }
    },
    dateRange: {
      get() {
        return {
          startDate: this.selectedStartDate,
          endDate: this.selectedEndDate,
        };
      },
      set(val) {
        this.$emit("selectedStartDate", val.startDate);
        this.$emit("selectedEndDate", val.endDate);
        this.dateRangeView.startDate = val.startDate;
        this.dateRangeView.endDate = val.endDate;
      },
    },
    //todo eğer testte sorunn olmazsa burası silinecek.
    // dateRangeView: {
    //   get(){
    //     return {
    //       startDate: this.selectedStartDate,
    //       endDate: this.selectedEndDate,
    //     }
    //   },
    //   set(val){
    //     this.$emit("selectedStartDate",val.startDate);
    //     this.$emit("selectedEndDate",val.endDate);
    //   }
    // },
  },
  mounted() {
    $(".selectpicker").selectpicker("refresh");
    $(".multipleDateRangePickerStart .form-control span").remove();
    this.windowWidth = window.innerWidth;
    this.$nextTick(() => {
      window.addEventListener("resize", this.onResize);
    });
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.onResize);
  },
  created() {
    this.id = this.idGenerator();
  },
  methods: {
    onResize() {
      this.windowWidth = window.innerWidth;
    },
    checkStartDateInputRules() {
      if (this.singleDatePickerMode || this.trainInformation) {
        if (this.isBirthdateInRange) {
          if (this.isAPet) {
            return { required: false };
          }
          return {
            required: true,
            regex: this.dateRegex,
            is_birthdate_in_range: {
              minMonths: this.passengerTypeCode > 0 ? this.passengerTypesMap[this.passengerTypeCode].minAge : 0,
              maxMonths: this.passengerTypeCode > 0 ? this.passengerTypesMap[this.passengerTypeCode].maxAge : 0,
              trips: {
                selectedGidisTrip: this.selectedGidisTrip,
                selectedDonusTrip:
                  this.selectedDonusTrip && this.selectedDonusTrip.trains && this.selectedDonusTrip.trains.length > 0 ? this.selectedDonusTrip : undefined,
              },
            },
          };
        } else {
          return { required: true, regex: this.dateRegex };
        }
      } else {
        if (this.isAPet) {
          return { required: false };
        } else if (this.isBirthdateInRange) {
          return {
            required: true,
            is_birthdate_in_range: {
              minMonths: this.passengerTypesMap[this.passengerTypeCode].minAge,
              maxMonths: this.passengerTypesMap[this.passengerTypeCode].maxAge,
              trips: {
                selectedGidisTrip: this.selectedGidisTrip,
                selectedDonusTrip:
                  this.selectedDonusTrip && this.selectedDonusTrip.trains && this.selectedDonusTrip.trains.length > 0 ? this.selectedDonusTrip : undefined,
              },
            },
          };
        } else {
          return { required: true };
        }
      }
    },
    validationTextFormat(text) {
      let fiterText = text.split(" ");
      let returnText = fiterText[0];
      for (let i = 1; i < fiterText.length; i++) {
        returnText += " " + fiterText[i].charAt(0).replace(/İ/gim, "i").toLowerCase() + fiterText[i].slice(1).toLowerCase();
      }
      return returnText;
    },
    setValue(event) {
      this.$emit("startDateInputEmit", event.target.value);
      if (!this.isStartDateInputReadonly) {
        if (event.target.value.length === 10) {
          if (!event.isTrusted) {
            return;
          }
          let dt = new Date(event.target.value.split(".").reverse().join("-"));
          let todayDate = new Date();
          let birthDate = new Date(dt).toISOString().split("T")[0];
          let validationRegex = /^(19|20)\d\d-\d{2}-\d{2}$/;
          let result = birthDate.toString().match(validationRegex);
          if (birthDate > todayDate || result === null) {
            let lastIndex = event.target.value.lastIndexOf(".");
            this.$emit("startDateInputEmit", event.target.value.slice(0, lastIndex + 1));
          } else {
            // this.$emit("dateRangeViewStartEmit", dt);
            // this.$emit("startDateInputEmit", this.dateFormatter(dt))
            // this.$emit("selectedStartDate", {dt: dt, isTrusted: true});
            this.dateRange.startDate = dt;
            this.dateRange.endDate = dt;
            this.dateRangeView.startDate = dt;
            this.dateRangeView.endDate = dt;
            if (Object.keys(this.$refs).length > 0) {
              //todo sorulacak. konsolda hata veriyor. sayfa yüklenirken multipleDateRangePickerStart olmadığı için refs'e kızıyor. bu yüzden if ile kontrol ediyoruz.
              this.$refs["multipleDateRangePickerStart" + this.id].$refs.calendarRef.year = dt.getFullYear();
              this.$refs["multipleDateRangePickerStart" + this.id].$refs.calendarRef.month = dt.getMonth();
              this.$refs["multipleDateRangePickerStart" + this.id].$refs.calendarRef.currentMonthDate = dt;
              this.$refs["multipleDateRangePickerStart" + this.id].dateClick(dt);
              // this.$refs['multipleDateRangePickerStart'+this.id].open = true; // eğer datepicker açık kalmasını istiyorsanız bu satırı açın
            }
            this.$nextTick(() => {
              $(".monthselect").selectpicker("refresh");
              $(".yearselect").selectpicker("refresh");
            });
          }
        }
      }
    },

    idGenerator() {
      let id = Math.floor(Math.random() * 1000 + new Date().getUTCMilliseconds());
      let ref = "multipleDateRangePickerStart" + id;
      this.$emit("idEmit", ref);
      return id;
    },
    // date picker start
    dateFormatter(date) {
      return this.singleDatePickerMode
        ? moment(new Date(date)).locale(this.selectedLanguage).format("DD.MM.YYYY")
        : moment(new Date(date)).locale(this.selectedLanguage).format("DD MMMM dddd");
    },
    toggleBorderClass(value) {
      $(".selectpicker").selectpicker("refresh");
      if (value) {
        this.dateBorderClass = true;
      } else {
        this.dateBorderClass = false;
      }
    },
    toggleEmitDate(value) {
      this.$emit("toggleEmitDate", value);
    },
    prevMonth(param) {
      this.prevMonthEl = param;
    },
    nextMonth(param) {
      this.nextMonthEl = param;
    },
    setDateRangeViewValues() {
      this.$emit("dateRangeViewStartEmit", this.dateRange.startDate);
      if (!this.dateRangePickerMode) {
        this.$emit("dateRangeViewEndEmit", this.dateRange.endDate);
      } else {
        if (!this.dateRangeView.endDate) {
          this.$emit("dateRangeViewEndEmit", null);
        }
      }
      this.$emit("dateRangeViewEndEmit", this.dateRange.endDate);
    },
    datePickerSwitchMode(mode) {
      // Vue.set(this,"dateRangePickerMode",mode);
      this.$emit("dateRangePickerModeEmit", mode);
      this.$emit("dateRangeViewEndEmit", null);

      // this.dateRangeView.endDate=null;
      // this.$emit("selectedStartDate", {dt: this.dateRange.startDate, isTrusted: false});
      this.$emit("selectedStartDate", this.dateRange.startDate);
      this.$emit("selectedEndDate", null);
      this.$emit("isEndDateInvalid", true);
    },
    // @Ditravo
    selectEndDateWithoutChangingStartDateDropdownEmit(mode) {
      this.$emit("selectEndDateWithoutChangingStartDateDropdownEmit", mode);
    },
    directionSelect(event) {
      if (event.target.value === "1") {
        this.dateRangePickerMode = false;
      }
      if (event.target.value === "2") {
        this.dateRangePickerMode = true;
      }
      $(".selectpicker").selectpicker("refresh");
    },
    // date picker end
    startDateSelection(startDate) {
      this.$emit("dateRangeViewStartEmit", startDate);
      //this.$emit("selectedStartDate", startDate);
      // this.$emit("dateRangeViewEndEmit", this.dateRange.endDate);
      // this.$emit("selectedStartDate",startDate);
    },
    //startDateSelection(startDate) {
    //  if (!this.dateRangePickerMode || moment(startDate).isAfter(moment(this.dateRangeView.endDate))) {
    //    this.$emit("selectedEndDate", startDate);
    //    this.$emit("dateRangeViewEndEmit", startDate);
    //    this.$emit("endDateInputEmit", this.dateFormatter(startDate));
    //    this.$emit("isEndDateInvalid", true);
    //    // border class sıfırlama
    //    setTimeout(() => {
    //      this.dateBorderClass = false;
    //    });
    //  }
    //  this.$emit("selectedStartDate", startDate);
    //  this.$emit("dateRangeViewStartEmit", startDate);
    //  this.$emit("startDateInputEmit", this.dateFormatter(startDate));
    //},
    finishDateSelection(endDate) {
      this.$emit("dateRangeViewEndEmit", endDate);
      this.dateRange.endDate = endDate;
      if (this.dateRangePickerMode) {
        this.$emit("isEndDateInvalid", true);
      } else {
        this.$emit("isEndDateInvalid", false);
      }
    },
    updateValues(event) {
      this.$emit("selectedStartDate", event.startDate);
      // this.startDateInput = this.formatDateRangeViewDate(this.dateRangeView.startDate);
      if (this.dateRangePickerMode) {
        this.$emit("selectedEndDate", event.endDate);
        // this.endDateInput = this.formatDateRangeViewDate(this.dateRangeView.endDate);
      } else {
        this.$emit("selectedEndDate", null);
      }
    },
    selectDate() {
      //TODO: Her 3. seçimde tarihler 0'lanmalı.
      //TODO: Yön değişimi olduğunda tarihler kırılıyor.
      // gidiş-dönüşteyken 2 tarih seçip pop içerisinden selectboxda tek yöne geçip sağdaki oklardan diğer aya bakılınca eski değerler duruyor
      if (moment(this.dateRangeView.startDate).isAfter(moment(this.dateRangeView.endDate))) {
        let tempDate = this.dateRangeView.endDate;
        this.$emit("dateRangeViewEndEmit", this.dateRangeView.startDate);
        // this.dateRangeView.endDate = this.dateRangeView.startDate;
        this.$emit("dateRangeViewStartEmit", tempDate);

        // this.dateRangeView.startDate = tempDate;
      }
      // gün seçildikten sonra border rengini değiştiriyor.
      setTimeout(() => {
        this.dateBorderClass = false;
      });
    },
    //selectDate(event) {
    //  //TODO: Her 3. seçimde tarihler 0'lanmalı.
    //  //TODO: Yön değişimi olduğunda tarihler kırılıyor.
    //  // gidiş-dönüşteyken 2 tarih seçip pop içerisinden selectboxda tek yöne geçip sağdaki oklardan diğer aya bakılınca eski değerler duruyor
    //  if (moment(this.dateRangeView.startDate).isAfter(moment(this.dateRangeView.endDate))) {
    //    let tempDate = this.dateRangeView.endDate;
    //    this.$emit("dateRangeViewEndEmit", this.dateRangeView.startDate);
    //    // this.dateRangeView.endDate = this.dateRangeView.startDate;
    //    this.$emit("dateRangeViewStartEmit", tempDate);
    //
    //    return;
    //    // this.dateRangeView.startDate = tempDate;
    //  }
    //  this.$emit("selectedStartDate", event.startDate);
    //  this.$emit("selectedEndDate", event.endDate);
    //  this.$emit("dateRangeViewStartEmit", event.startDate);
    //  this.$emit("dateRangeViewEndEmit", event.endDate);
    //  this.$emit("startDateInputEmit", this.dateFormatter(event.startDate));
    //  this.$emit("endDateInputEmit", this.dateFormatter(event.endDate));
    //  // gün seçildikten sonra border rengini değiştiriyor.
    //  setTimeout(() => {
    //    this.dateBorderClass = false;
    //  });
    //},
    formatDateRangeViewDate(value) {
      if (this.dateRangePickerMode) {
        this.dateRangeView.endDate = this.selectedEndDate;
      }
      if (value === null) return "";
      return this.singleDatePickerMode
        ? moment(value).locale(this.selectedLanguage).format("DD.MM.YYYY")
        : moment(value).locale(this.selectedLanguage).format("DD MMMM dddd");
    },
    checkDirection(touchstartX, touchendX) {
      if (touchendX + 40 < touchstartX) {
        if (!this.nextMonthEl) return;
        this.nextMonthEl.click();
      }
      if (touchendX > touchstartX + 40) {
        if (!this.prevMonthEl) return;
        this.prevMonthEl.click();
      }
    },
    selectDay(mod) {
      // date range picker içerisinde bir butona click yapınca date range picker açılmasını engelliyor.
      setTimeout(() => {
        let ref = "multipleDateRangePickerStart" + this.id;
        this.$refs[ref].open = false;
      });
      switch (mod) {
        case "today":
          let newDate = new Date();
          this.dateRange.startDate = newDate;
          this.$emit("dateRangeViewStartEmit", newDate);
          this.$emit("selectedStartDate", newDate);
          this.$emit("startDateInput", this.formatDateRangeViewDate(newDate));

          // start date seçildikten sonra end date içerisine atıyor
          setTimeout(() => {
            // this.$emit("dateRangeViewEndEmit", this.dateRangeView.startDate);
            // this.$emit("selectedEndDate",this.dateRangeView.startDate);
            this.dateRange.endDate = newDate;
            this.$emit("dateRangeViewEndEmit", null);
            this.$emit("selectedEndDate", null);
            // start date input
            this.$emit("startDateInputEmit", this.formatDateRangeViewDate(new Date()));
            // !? sor
            // this.$emit(this.dateRange,"endDate",null);
          });
          // end date input
          this.$emit("endDateInput", null);
          this.$emit("endDateInputEmit", null);
          // validasyon kapatmak ve dönüş alanını açmak için
          this.datePickerSwitchMode(false);
          this.$emit("isEndDateInvalid", true);
          break;
        case "tomorrow":
          let today = new Date();
          let tomorrow = new Date(new Date().setDate(today.getDate() + 1));
          // '?' kaldırılınca console da hata veriyor tek yön olduğu durumda end daye boş olduğu için
          let currentEndDate = this.dateRange.endDate?.getDate();
          if (tomorrow.getDate() > this.$emit("dateRangeViewEndEmit", currentEndDate)) return;
          this.$emit("dateRangeViewStartEmit", tomorrow);
          this.$emit("selectedStartDate", tomorrow);
          this.dateRange.startDate = tomorrow;
          this.dateRange.endDate = tomorrow;

          // dateRangeView
          this.$emit("dateRangeViewEndEmit", tomorrow);
          this.$emit("selectedEndDate", tomorrow);
          // end date input
          this.$emit("endDateInput", null);
          this.$emit("endDateInputEmit", null);
          // validasyon kapatmak ve dönüş alanını açmak için
          this.datePickerSwitchMode(false);
          this.$emit("isEndDateInvalid", true);
          // start date seçildikten sonra end date içerisine atıyor
          setTimeout(() => {
            this.$emit("dateRangeViewEndEmit", this.dateRangeView.startDate);
            this.$emit("selectedEndDate", this.dateRangeView.startDate);
          });
          // start date input
          this.$emit("startDateInputEmit", this.formatDateRangeViewDate(tomorrow));
          break;
        case "same-day":
          //TODO: hata at
          if (!this.dateRange.startDate) {
            this.$emit("isEndDateInvalid", false);
            return;
          }
          // validasyon kapatmak ve dönüş alanını açmak için
          this.datePickerSwitchMode(true);
          this.$emit("isEndDateInvalid", true);
          // dateRangeView
          this.$emit("dateRangeViewEndEmit", this.dateRange.startDate);
          this.$emit("selectedEndDate", this.dateRangeView.startDate);
          // end date input
          this.$emit("endDateInput", this.dateFormatter(this.startDateInput));
          this.$emit("endDateInputEmit", this.dateFormatter(this.dateRange.startDate));

          break;
        case "next-day":
          //TODO: hata at
          if (!this.dateRange.startDate) {
            this.$emit("isEndDateInvalid", false);
            return;
          }
          // validasyon kapatmak ve dönüş alanını açmak için
          this.datePickerSwitchMode(true);
          this.$emit("isEndDateInvalid", true);

          let nextDay = new Date(new Date().setDate(new Date(this.dateRange.startDate).getDate() + 1));
          if (nextDay < this.dateRange.startDate) return;
          this.dateRange.endDate = nextDay;
          // dateRangeView
          this.$emit("dateRangeViewEndEmit", nextDay);
          this.$emit("selectedEndDate", nextDay);
          // end date input
          let currentEndDateInput = moment(nextDay).locale(this.selectedLanguage).format("DD MMMM dddd");
          this.$emit("endDateInput", currentEndDateInput);
          this.$emit("endDateInputEmit", currentEndDateInput);
          break;
        default:
          throw "unexpected mod.";
      }
    },
    directionDropdownCloseDateRangePicker(mode) {
      if (!mode) {
        this.finishDateSelection(this.dateRange.startDate);
        this.$refs["multipleDateRangePickerStart" + this.id].open = false;
        this.$nextTick(() => {
          this.dateRange.endDate = this.dateRange.startDate;
          this.$refs["multipleDateRangePickerStart" + this.id].open = true;
        });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.customMultipleDateRangePicker {
  .headerArea {
    @media (min-width: 767px) {
      display: block !important;
    }
  }

  .calendars {
    .calendars-container {
      .drp-calendar {
        table {
          tbody {
            tr {
              td {
                &:hover {
                  background-color: var(--very-light-blue);
                }

                &.today {
                  &.disabled {
                    &::before {
                      color: var(--black) !important;
                    }

                    span {
                      color: var(--black) !important;
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
}

.singleDatePickerMode {
  .dateInputArea {
    margin: 0;

    &::before {
      margin-top: 0;
      height: 100%;
      margin-left: 0;
      width: 100%;
      border: 0;
    }

    .invalid-feedback-inline {
      font-size: 12px;
      font-weight: 500;
      color: var(--orangey-red);
      position: absolute;
      left: 11px;
      line-height: normal;
      margin: 4px 0 0;
    }

    .datePickerInput {
      &.departureDate {
        &::after {
          display: none;
        }

        .form-label-group {
          input {
            border: 1px solid var(--grey-purple-44);
            background-color: #fafafa;
            padding: 0;
            height: calc(2.5em + 0.75rem + 1.5px);
            padding-left: 16px;

            &::placeholder {
              font-size: 14px !important;
              color: #6c757d !important;
            }
          }

          &::after {
            right: 17px !important;
          }
        }
      }
    }
  }

  .daterangepicker {
    &::before {
      display: none;
    }

    &.opensright {
      right: 0px;
      left: auto !important;
      margin-right: -2px !important;
      margin-top: -28px !important;
      @media (max-width: 767px) {
        margin-top: 0px !important;
        margin-right: 0 !important;
      }
    }

    .calendars {
      min-height: 435px;

      .calendars-container {
        margin-bottom: 19px;

        .drp-calendar {
          max-width: 100%;

          &.left {
            margin-right: 34px;
          }

          table {
            thead {
              tr {
                th {
                  &.prev {
                    right: 50px;
                    @media (max-width: 767px) {
                      display: table-cell;
                    }
                  }

                  &.next {
                    right: 4px !important;
                    @media (max-width: 767px) {
                      display: table-cell;
                    }
                  }

                  &.month {
                    padding: 0;
                    border: 0px;

                    .filter-option-inner {
                      font-size: 12px !important;
                    }

                    button {
                      &.btn-light {
                        &.dropdown-toggle {
                          border: none !important;
                          width: auto !important;
                          padding-left: 0 !important;

                          &:focus {
                            box-shadow: none !important;
                          }

                          .filter-option-inner {
                            display: inline-flex;
                          }

                          .filter-option-inner-inner {
                            font-size: 14px;
                            font-weight: 600;
                            color: black;
                          }
                        }
                      }

                      &::after {
                        margin-left: 8px;
                        position: absolute;
                        top: 50%;
                        margin-top: -6px;
                        color: black;
                        background-color: transparent;
                        border-top: 2px solid !important;
                        border-right: 2px solid !important;
                      }
                    }
                  }

                  .customSelect {
                    justify-content: start;

                    .monthselect {
                      margin: 0 !important;
                      padding: 0;

                      .dropdown-menu {
                        &.show {
                          ul {
                            li {
                              a {
                                span {
                                  &.text {
                                    font-size: 13px !important;
                                  }
                                }

                                padding-left: 15px !important;
                                padding-right: 15px !important;
                              }
                            }
                          }
                        }
                      }
                    }

                    .yearselect {
                      margin: 0 !important;
                      padding: 0;

                      .dropdown-menu {
                        &.show {
                          ul {
                            li {
                              a {
                                span {
                                  &.text {
                                    font-size: 13px !important;
                                  }
                                }

                                padding-left: 15px !important;
                                padding-right: 15px !important;
                              }
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            }

            tbody {
              tr {
                td {
                  &.start-date {
                    &::before {
                      content: "" !important;
                    }
                  }

                  width: 50px;
                  height: 50px;
                  min-width: 50px;
                  @media (max-width: 575px) {
                    width: 40px;
                    height: 40px;
                    min-width: 40px;
                  }
                }
              }
            }
          }
        }
      }

      .footerArea {
        @media (max-width: 767px) {
          display: block !important;
        }
      }
    }
  }

  .reportrange-text {
    display: block;
  }

  @media (max-width: 767px) {
    .footerArea {
      display: block !important;
    }
  }

  .slide-in-left {
    -webkit-animation: slide-in-left 0.2s cubic-bezier(0.25, 0.46, 0.45, 0.94) both;
    animation: slide-in-left 0.2s cubic-bezier(0.25, 0.46, 0.45, 0.94) both;
  }

  @-webkit-keyframes slide-in-left {
    0% {
      -webkit-transform: translateX(-50px);
      transform: translateX(-50px);
      opacity: 0;
    }
    100% {
      -webkit-transform: translateX(0);
      transform: translateX(0);
      opacity: 1;
    }
  }
  @keyframes slide-in-left {
    0% {
      -webkit-transform: translateX(-50px);
      transform: translateX(-50px);
      opacity: 0;
    }
    100% {
      -webkit-transform: translateX(0);
      transform: translateX(0);
      opacity: 1;
    }
  }

  .slide-in-right {
    -webkit-animation: slide-in-right 0.2s cubic-bezier(0.25, 0.46, 0.45, 0.94) both;
    animation: slide-in-right 0.2s cubic-bezier(0.25, 0.46, 0.45, 0.94) both;
  }

  @-webkit-keyframes slide-in-right {
    0% {
      -webkit-transform: translateX(50px);
      transform: translateX(50px);
      opacity: 0;
    }
    100% {
      -webkit-transform: translateX(0);
      transform: translateX(0);
      opacity: 1;
    }
  }
  @keyframes slide-in-right {
    0% {
      -webkit-transform: translateX(50px);
      transform: translateX(50px);
      opacity: 0;
    }
    100% {
      -webkit-transform: translateX(0);
      transform: translateX(0);
      opacity: 1;
    }
  }

  .fade-in {
    -webkit-animation: fade-in 0.2s cubic-bezier(0.39, 0.575, 0.565, 1) both;
    animation: fade-in 1.2s cubic-bezier(0.39, 0.575, 0.565, 1) both;
  }

  @-webkit-keyframes fade-in {
    0% {
      opacity: 0;
    }
    100% {
      opacity: 1;
    }
  }
  @keyframes fade-in {
    0% {
      opacity: 0;
    }
    100% {
      opacity: 1;
    }
  }
}

.trainInformationDatePicker {
  .reportrange-text {
    background-color: transparent !important;
    overflow: visible;
  }

  .daterangepicker {
    &.opensright {
      margin-left: -41px;
      margin-top: 5px !important;

      @media (max-width: 767px) {
        margin-top: 0px !important;
      }
    }

    .headerArea {
      .calenderPurpleImg {
        min-width: 100%;
        background-position-x: 90%;
      }
    }
  }

  .dateInputArea {
    .datePickerInput {
      &.departureDate {
        .form-control {
          padding: 0;
          @media (min-width: 767px) {
            box-shadow: none;
          }
          @media (max-width: 767px) {
            background-color: var(--white);
          }
        }

        .invalid-feedback-inline {
          margin-top: -14px; //todo
        }
      }
    }
  }
}

.minWidth350 {
  min-width: 350px;
}
</style>
